import {useMutation, useQueryClient} from '@tanstack/react-query';
import {updateOperatorProfile, updateAdminProfile} from "./profile-api";

export function useUpdateProfile() {
    const qc = useQueryClient();
    const role = localStorage.getItem("role") || 'OPERATOR';

    // A SUPERVISOR has no operators row and no admins row — the account is a system_users row and
    // nothing else, deliberately, so the assignment scheduler can never route work to them. That
    // leaves no self-profile endpoint to save to: routing them to updateOperatorProfile sent a
    // supervisor's name change to /operator/update, which answered 403 every time. The screen now
    // shows their name read-only instead, so this branch should be unreachable; it fails loudly
    // rather than firing a request that cannot succeed.
    const mutationFn =
        role === "ADMIN"
            ? updateAdminProfile
            : role === "SUPERVISOR"
                ? () => Promise.reject(new Error("A supervisor's name is set by an administrator."))
                : updateOperatorProfile;

    return useMutation({
        mutationFn,
        onSuccess: () => {
            qc.invalidateQueries({queryKey: ["user", "profile", role]});
        },
    });
}